export default {
  'component.globalHeader.search': 'Cerca interna',
  'component.globalHeader.search.example1': 'Suggeriment de cerca un',
  'component.globalHeader.search.example2': 'Suggeriment de cerca dos',
  'component.globalHeader.search.example3': 'Suggeriment de cerca tres',
  'component.globalHeader.help': 'Documentació',
  'component.globalHeader.notification': 'Notificacions',
  'component.globalHeader.notification.empty': 'Has vist totes les notificacions',
  'component.globalHeader.message': 'Missatges',
  'component.globalHeader.message.empty': 'Has llegit tots els missatges',
  'component.globalHeader.event': 'Pendent',
  'component.globalHeader.event.empty': 'Has completat totes les tasques pendents',
  'component.noticeIcon.clear': 'Buidar',
  'component.noticeIcon.cleared': 'Buidat',
  'component.noticeIcon.empty': 'No hi ha dades',
  'component.noticeIcon.view-more': 'Veure més',
};
